// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".showPrice[data-v-0a020ed1]{background-color:#1c1c1c;border:none;border-radius:5px;color:#f1f1f1;cursor:pointer;font-size:13px;font-weight:500;height:40px;text-transform:uppercase;width:150px}.vue-star-rating[data-v-0a020ed1]{display:block!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
